import { render } from "./UsersTable.vue?vue&type=template&id=a624fbfc&scoped=true"
import script from "./UsersTable.vue?vue&type=script&lang=js"
export * from "./UsersTable.vue?vue&type=script&lang=js"

import "./UsersTable.vue?vue&type=style&index=0&id=a624fbfc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a624fbfc"]])

export default __exports__